var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCircleLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 13.7505V8.75049H16.2507V13.7505H21.2507V16.2505H16.2507V21.2505H13.7507V16.2505H8.75073V13.7505H13.7507ZM15.0007 27.5005C8.09698 27.5005 2.50073 21.9042 2.50073 15.0005C2.50073 8.09674 8.09698 2.50049 15.0007 2.50049C21.9045 2.50049 27.5007 8.09674 27.5007 15.0005C27.5007 21.9042 21.9045 27.5005 15.0007 27.5005ZM15.0007 25.0005C17.6529 25.0005 20.1964 23.9469 22.0718 22.0716C23.9472 20.1962 25.0007 17.6527 25.0007 15.0005C25.0007 12.3483 23.9472 9.80479 22.0718 7.92942C20.1964 6.05406 17.6529 5.00049 15.0007 5.00049C12.3486 5.00049 9.80503 6.05406 7.92967 7.92942C6.0543 9.80479 5.00073 12.3483 5.00073 15.0005C5.00073 17.6527 6.0543 20.1962 7.92967 22.0716C9.80503 23.9469 12.3486 25.0005 15.0007 25.0005Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleLine);
export default __webpack_public_path__ + "static/media/add-circle-line.b0b73f79.svg";
export { ForwardRef as ReactComponent };